export class CouponCampaignsAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The market's campaigns with what each reserved, issued, redeemed and held out, and the governed state of every policy it needs (`coupon_campaign:view`). */
    list(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/coupon-campaigns?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** PROPOSE a campaign (the maker, `coupon_campaign:manage`); a protected attribute in the body is `400 CAMPAIGN_PROTECTED_ATTRIBUTE`; no policy or fund is `409`. */
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/coupon-campaigns', body: input, auth: true });
    }
    /** The checker (never the proposer, `coupon_campaign:approve`) approves or refuses; approval RESERVES the budget (`409 CAMPAIGN_RESERVE_REFUSED` if the fund refuses); `403 CAMPAIGN_SELF_APPROVAL` for the proposer. */
    decide(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/coupon-campaigns/${encodeURIComponent(campaignId)}/decision`, body: input, auth: true });
    }
    /** KILL an active campaign (`coupon_campaign:manage`): one operator is enough; the unused reservation is released. */
    end(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/coupon-campaigns/${encodeURIComponent(campaignId)}/end`, body: input, auth: true });
    }
    /** Restart an ended campaign as a NEW proposal with a fresh window - four eyes again (`coupon_campaign:manage`). */
    restart(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/coupon-campaigns/${encodeURIComponent(campaignId)}/restart`, body: input, auth: true });
    }
}
//# sourceMappingURL=coupon-campaigns.js.map